import logo1 from '../src/assets/logo1.webp';
import logo2 from '../src/assets/logo2.webp';
import logo3 from '../src/assets/logo3.webp';
import logo4 from '../src/assets/logo4.webp';



const scholarshipData = [


  {
    logo: logo1,
    title: "title1",
    content: "content1"
  },
  {
    logo: logo2,
    title: "title2",
    content: "content2",

    stats: [
      { number: "n1", label: 'label1' },
      { number: 'n2', label: 'label2' },
      { number: 'n3', label: 'label3' },
    ],
  },
  {
    logo: logo3,
    title: "title3",
    content: `content3`,
    stats: [
      { number: 'n4', label: 'label4' },
      { number: 'n5', label: 'label5' },
      { number: 'n6', label: 'label6' },
      { number: 'n7', label: 'label7' },
    ],
  },
  {
    logo: logo4,
    title: "title4",
    content: "content4",
  },
];

export default scholarshipData;
